module.exports = __webpack_public_path__ + "static/img/interpretive-writing01.9ced707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/content-development/interpretive-writing01.jpg
// module id = 997
// module chunks = 0